export default {
  SESSION_STORAGE_COMPARISON_ITEMS: 'comparisonItems',
  SESSION_STORAGE_COMPARISON_LAST_PAGE_PATH: 'comparisonLastPagePath',
  SESSION_STORAGE_COMPARISON_BACK_LINK_LABEL: 'comparisonBackLinkLabel'
};
